import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { clearAuth } from "../_redux/AuthSlice";
import { authService } from "../api/authApi";
import Loader from "../components/Loader/Loader";
import getUserDetails from "./getUserInfo";

const AuthGuard = ({
  allowedRoles,
  allowedClients = null,
  allowedProjects = null,
  requireReports = false,
}) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const validateSession = async () => {
      try {
        // Load local user details
        const localUser = await getUserDetails();
        if (localUser?.userId) {
          setUser(localUser);
          setAuthenticated(true);
          setLoading(false);
          return;
        }

        // Validate with backend
        // const response = await authService.getCurrentUser();
        // if (response?.success && response?.user) {
        //   setUser(response.user);
        //   setAuthenticated(true);
        // } else {
        //   dispatch(clearAuth());
        //   navigate('/ats/login', { replace: true });
        // }
      } catch (error) {
        dispatch(clearAuth());
        navigate("/ats/login", { replace: true });
      } finally {
        setLoading(false);
      }
    };

    validateSession();
  }, []);

  if (loading) return <Loader />;

  if (!authenticated || !user) {
    return <Navigate to="/ats/login" replace />;
  }

  // Access Control Logic
  const userRole = user.systemRole;
  const projectStatus = user.projectStatus;
  const clientStatus = user.clientStatus;
  const userFeatures = user.features || "";
  const featuresArray = userFeatures
    .split(",")
    .map((f) => f.trim().toLowerCase());

  // Role validation
  if (allowedRoles?.length) {
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/layout/404" replace />;
    }
  }

  // Client validation
  if (allowedClients !== null && allowedClients !== clientStatus) {
    return <Navigate to="/layout/404" replace />;
  }

  // Project validation
  if (allowedProjects !== null && allowedProjects !== projectStatus) {
    return <Navigate to="/layout/404" replace />;
  }

  // Reports validation - requires 'reports' in features
  if (requireReports) {
    if (!featuresArray.includes("reports")) {
      return <Navigate to="/layout/404" replace />;
    }
  }

  return <Outlet />;
};

export default AuthGuard;
